import transition from '../shared/transition'

const getTransition = ({ property = 'all', easing = transition.animation, timing = transition.timing }) =>
  `${property} ${easing} ${timing}`

export default getTransition
